import { useMutation, useQueryClient } from '@tanstack/react-query';

import InclusionsService from '~/services/InclusionsService';

import { inclusionsQueryKeys } from './inclusionsQueryKeys';

interface PackageInclusionOrder {
  inclusion_id: string;
  sort_order: number;
}

interface CopyPackageInclusionsOrderParams {
  offerId: string;
  vendorId: string;
  packageIds: Array<string>;
  packageInclusions: Array<PackageInclusionOrder>;
}

export function useCopyPackageInclusionsOrder() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ offerId, vendorId, packageIds, packageInclusions }: CopyPackageInclusionsOrderParams) => {
      return await InclusionsService.copyInclusionsOrder(vendorId, offerId, {
        packages: packageIds,
        package_inclusions: packageInclusions,
      });
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: inclusionsQueryKeys.packageInclusionsByOffer(variables.offerId) });
    },
  });
}
